<script lang="ts">
	import type { PageData } from './$types';
	import Page from '$components/Page/Page.svelte';

	let {
		data
	}: {
		data: PageData;
	} = $props();
</script>

<Page page={data.page} />
